import { landingPage } from 'utils/pageTemplates/landingPage';

const { getStaticProps, getStaticPaths, LandingPageComponent } =
  landingPage('supplements');

export { getStaticPaths, getStaticProps };
export default LandingPageComponent;
